/**
 * Scroll reveal - adds .is-visible class when elements enter viewport.
 *
 * @package denva
 */

( function() {
	'use strict';

	var targets = document.querySelectorAll( '.block-intro, .block-designers-link, .block-designers, .block-offer, .block-values, .block-image-hero, .event-concept, .block-collaboration, .block-lookbooks, .contact-block' );
	if ( ! targets.length ) return;

	var observer = new IntersectionObserver( function( entries ) {
		entries.forEach( function( entry ) {
			if ( entry.isIntersecting ) {
				entry.target.classList.add( 'is-visible' );
				observer.unobserve( entry.target );
			}
		} );
	}, { threshold: 0.15 } );

	targets.forEach( function( el ) {
		observer.observe( el );
	} );
} )();
